import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { clearMessages, updatePassword } from '../../slices/commonReducer';
import toast from 'react-hot-toast';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { extractErrorMessage } from '../../constants/common';


const ResetPasswordOffcanvas = ({ showModal, handleModalClose }) => {
    const dispatch = useDispatch();
    const { successMsg, errorMsg } = useSelector(state => state.common);
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
    });
    const [errors, setErrors] = useState('');
    // ✅ Password visibility toggles - move here!
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        dispatch(clearMessages());
        let validationErrors = {};

        if (!formData.oldPassword || formData.oldPassword.trim() === '') {
            validationErrors.oldPassword = 'Old Password field is empty';
        }

        if (!formData.newPassword || formData.newPassword.trim() === '') {
            validationErrors.newPassword = 'New Password field is empty';
        }

        if (!formData.repeatPassword || formData.repeatPassword.trim() === '') {
            validationErrors.repeatPassword = 'Repeat New Password field is empty';
        }

        if (formData.newPassword !== formData.repeatPassword) {
            validationErrors.general = 'Passwords do not match!';
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const { oldPassword, newPassword, repeatPassword } = formData;

        try {
            const res = await dispatch(updatePassword({ oldPassword, newPassword, repeatPassword })).unwrap();

            if (res?.type === 'success') {
                 toast.success(res?.message);
                 modalClose();
            } 
        } catch (error) {
            const errorMessage = extractErrorMessage(error);
            toast.error(errorMessage);
        }
    };

    const modalClose = () => {
        setFormData({
            oldPassword: '',
            newPassword: '',
            repeatPassword: '',
        })
        setErrors('')
        dispatch(clearMessages())
        handleModalClose()
    }


    useEffect(() => {
        dispatch(clearMessages());
    }, [showModal])

    if (!showModal) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="offcanvas-backdrop fade show"
                onClick={modalClose}
                style={{ zIndex: 1040 }}
            ></div>

            {/* Offcanvas */}
            <div
                className={`offcanvas offcanvas-end show`}
                style={{
                    visibility: 'visible',
                    width: '500px',
                    zIndex: 1045,
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    height: '100vh',
                    backgroundColor: '#fff',
                    boxShadow: '-0.5rem 0 1rem rgba(0, 0, 0, 0.15)'
                }}
            >
                {/* Header */}
                <div className="offcanvas-header bg-light border-bottom">
                    <h5 className="offcanvas-title">Update Password</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={modalClose}
                        aria-label="Close"
                    ></button>
                </div>

                {/* Body */}
                <div className="offcanvas-body p-4">
                    <Row>
                        <Col xl={12} lg={12}>
                            <div className="new-user-info">
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12} className="mb-3">
                                            <Form.Group controlId="oldPassword">
                                                <Form.Label>Old Password:</Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type={showOldPassword ? "text" : "password"}
                                                        placeholder="Password"
                                                        value={formData.oldPassword}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.oldPassword}
                                                        autocomplete="new-password"
                                                    />
                                                    <span
                                                        className="position-absolute end-0 top-0 mt-2 me-3"
                                                        onClick={() => setShowOldPassword(prev => !prev)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </span>

                                                </div>
                                                {errors.oldPassword && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.oldPassword}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>

                                        </Col>

                                        <Col xs={12} className="mb-3">
                                            <Form.Group controlId="newPassword">
                                                <Form.Label>New Password:</Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type={showNewPassword ? "text" : "password"}
                                                        placeholder="New Password"
                                                        value={formData.newPassword}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.newPassword}
                                                    />
                                                    <span
                                                        className="position-absolute end-0 top-0 mt-2 me-3"
                                                        onClick={() => setShowNewPassword(prev => !prev)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </span>

                                                </div>
                                                {errors.newPassword && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.newPassword}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>

                                        </Col>

                                        <Col xs={12} className="mb-3">
                                            <Form.Group controlId="repeatPassword">
                                                <Form.Label>Repeat New Password:</Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type={showRepeatPassword ? "text" : "password"}
                                                        placeholder="Repeat Password"
                                                        value={formData.repeatPassword}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.repeatPassword}
                                                    />
                                                    <span
                                                        className="position-absolute end-0 top-0 mt-2 me-3"
                                                        onClick={() => setShowRepeatPassword(prev => !prev)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {showRepeatPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </span>

                                                </div>
                                                {errors.repeatPassword && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.repeatPassword}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>

                                        </Col>
                                    </Row>


                                    <div className="d-flex gap-2 mt-4">

                                        <Button
                                            type="button"
                                            variant="outline-secondary"
                                            onClick={modalClose}
                                            className="no-hover"
                                        >
                                            Cancel
                                        </Button>
                                        <Button type="submit" className="btn btn-primary">
                                            Submit
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default ResetPasswordOffcanvas